import userService from "../../../services/userService/userService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ROLES } from "../../../utils/constants";

const useRoles = () =>
  useQuery<string[], Error>({
    queryKey: [CACHE_KEY_ROLES],
    queryFn: userService.GetRoles,
  });

export default useRoles;
